import React from "react";
import localization from "../../statics/localization";
import { publicationDate, publicationStart } from "../../utils/publication";
import { languageCode } from "../../utils/uiLanguage";
import "./PublicationNotice.scss";

export default function PublicationNotice({ item, trailerUnavailable = false, compact = false }) {
  const date = publicationDate(publicationStart(item));
  const locale = languageCode(localization.getLanguage());
  const timeZone = "Europe/Istanbul";

  return (
    <div className={`vod-publication-notice${compact ? " vod-publication-notice-compact" : ""}`} role="status">
      <div className="vod-publication-symbol" aria-hidden="true">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="16" rx="4" />
          <path d="M7 3v4m10-4v4M3 10h18" />
          <path d="m10 14 4 2-4 2v-4Z" fill="currentColor" stroke="none" />
        </svg>
      </div>
      <div className="vod-publication-copy">
        <span className="vod-publication-badge">
          <span className="vod-publication-dot" aria-hidden="true" />
          {localization.comingSoon}
        </span>
        {date ? (
          <div className="vod-publication-schedule">
            <span className="vod-publication-label">{localization.availableFrom}</span>
            <time className="vod-publication-date" dateTime={date.toISOString()}>
              <span>{date.toLocaleDateString(locale, { timeZone, year: "numeric", month: "long", day: "numeric" })}</span>
              <span className="vod-publication-time">
                {date.toLocaleTimeString(locale, { timeZone, hour: "2-digit", minute: "2-digit" })}
              </span>
            </time>
          </div>
        ) : (
          <span className="vod-publication-pending">{localization.publicationDatePending}</span>
        )}
        {trailerUnavailable && (
          <span className="vod-publication-trailer">
            <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="3" />
              <path d="m10 9 5 3-5 3V9Z" />
            </svg>
            {localization.trailerUnavailable}
          </span>
        )}
      </div>
    </div>
  );
}
